const isBundle = (lineItemRaw)=>lineItemRaw.__typename === 'LineItemBundle'
;
const getDisplayType = (lineItemRaw, intl)=>{
    let productType;
    if (isBundle(lineItemRaw)) {
        productType = lineItemRaw.bundleLineItemsType;
    } else {
        productType = lineItemRaw.legacyProduct.productType;
    }
    const camelCasedProductType = productType.toLowerCase().replace(/(-|_)[a-z]/g, (match)=>{
        return match[1] ? match[1].toUpperCase() : '';
    });
    return intl.getLabel(`cart.lineItem.displayType.${camelCasedProductType}`);
};

export { getDisplayType };
//# sourceMappingURL=get-display-type.js.map
